import React from 'react';
import './GameHeader.css';

const GameHeader = ({ title = '6max Cash Game', currentHand = 1, totalHands = 10, onCancel }) => {
  const progress = (currentHand / totalHands) * 100;

  return (
    <div className="game-header">
      <div className="header-top">
        <h1>{title}</h1>
        <a
          href="#"
          className="cancel-link"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </a>
      </div>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="hand-counter">
        {currentHand}/{totalHands}
      </div>
    </div>
  );
};

export default GameHeader;
